// extracted by mini-css-extract-plugin
export default {"container__labels":"styles_container__labels__jbI+w"};